module.exports = "data:text/x-markdown;base64,WW91IGtub3cgdGhlIGJhc2ljcyBvZiBob3cgZXRoZXIgZ29lcyBpbiBhbmQgb3V0IG9mIGNvbnRyYWN0cywgaW5jbHVkaW5nIHRoZSB1c2FnZSBvZiB0aGUgZmFsbGJhY2sgbWV0aG9kLgoKWW91J3ZlIGFsc28gbGVhcm50IGFib3V0IE9wZW5aZXBwZWxpbidzIE93bmFibGUgY29udHJhY3QsIGFuZCBob3cgaXQgY2FuIGJlIHVzZWQgdG8gcmVzdHJpY3QgdGhlIHVzYWdlIG9mIHNvbWUgbWV0aG9kcyB0byBhIHByaXZpbGVkZ2VkIGFkZHJlc3MuCgpNb3ZlIG9uIHRvIHRoZSBuZXh0IGxldmVsIHdoZW4geW91J3JlIHJlYWR5IQo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fallback_complete.md
// module id = 1374
// module chunks = 0